<template>
  <div class="ap-page">
    <b-tabs card lazy v-model="activeTab" class="ap-tabs">
      <b-tab title="LIST PRODUCTS" :title-link-class="'ap-tab-link'">
        <keep-alive>
          <ProductsListProducts />
        </keep-alive>
      </b-tab>

      <!-- <b-tab title="CATALOG" :title-link-class="'ap-tab-link'">
        <keep-alive>
          <ProductCatalog />
        </keep-alive>
      </b-tab> -->

      <b-tab title="ON SALE" :title-link-class="'ap-tab-link'">
        <keep-alive>
          <SaleItemsView sale-type="Sale" />
        </keep-alive>
      </b-tab>

      <b-tab title="CLEARANCE" :title-link-class="'ap-tab-link'">
        <keep-alive>
          <SaleItemsView sale-type="Clearance" />
        </keep-alive>
      </b-tab>

      <b-tab title="PROMO" :title-link-class="'ap-tab-link'">
        <keep-alive>
          <SaleItemsView sale-type="Promo" />
        </keep-alive>
      </b-tab>
      <b-tab title="SPIFF" :title-link-class="'ap-tab-link'">
      <keep-alive>
        <SaleItemsView sale-type="Spiff" />
      </keep-alive>
    </b-tab>

      <b-tab title="AS IS" :title-link-class="'ap-tab-link'">
        <keep-alive>
          <SaleItemsView sale-type="AsIs" />
        </keep-alive>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ProductsListProducts from "@/components/Products/ProductsListProducts";
import ProductCatalog from "@/components/Products/ProductCatalog";
import SaleItemsView from "@/components/Products/SaleItemsView";

export default {
  name: "AllProductsPage",
  components: {
    ProductsListProducts,
    ProductCatalog,
    SaleItemsView
  },
  data() {
    return {
      activeTab: 0
    };
  }
};
</script>

<style scoped>
.ap-page { padding: 8px; }
.ap-tabs >>> .nav-tabs {
  border-bottom: 2px solid #E5E1DA;
  gap: 4px;
}
.ap-tabs >>> .nav-tabs .nav-link {
  border: 1.5px solid #E5E1DA;
  border-bottom: none;
  border-radius: 10px 10px 0 0;
  font-weight: 700;
  font-size: 13.5px;
  color: #736C63;
  padding: 10px 20px;
  background: #F7F5F2;
}
.ap-tabs >>> .nav-tabs .nav-link.active {
  background: #221F1C;
  color: #FFB06B;
  border-color: #221F1C;
}
</style>


// WEBPACK FOOTER //
// src/components/Products/AllProductsPage.vue